import { Ng2StateDeclaration } from "@uirouter/angular";
import { SearchActivitiesComponent } from "./search-activities.component";
import { WorkSchedulesComponent } from "./work-schedules.component";
import { WorkScheduleComponent } from "./work-schedule.component";
import { WorkScheduleMustersComponent } from "./work-schedule-musters.component";
import { EditWorkScheduleComponent } from "./work-schedule.edit.component";
import { WorkSchedulesDataService } from "../core/workschedules.dataservice";
import { ServiceConfig } from "../core/core.constants";
import { DayActitiesComponent } from "./daily-activities/day-activities.component";
import { ClearActivities } from "./clear-activities.component";
import { OverviewComponent } from "./overview/overview.component";
import { TimeBalanceMailComponent } from "./time-balance-mail.component";
import { AdjustmentsComponent } from "./adjustments/adjustments.component";
import { AdjustmentComponent } from "./adjustments/adjustment.component";

export const activitiesState: Ng2StateDeclaration = {
    name: "app.activities",
    url: "/activities",
    abstract: true
};

export const searchActivitiesState: Ng2StateDeclaration = {
    name: "app.activities.search",
    url: "/search",
    views: {
        "main-view@app": {
            component: SearchActivitiesComponent
        }
    }
};

export const dayState: Ng2StateDeclaration = {
    name: "app.activities.day",
    url: "/day",
    views: {
        "main-view@app": {
            component: DayActitiesComponent
        }
    },
    resolve: {
        date: () => new Date(),
        workplaceId: () => -1,
        workgroupId: () => -1
    }
};

export const dayWithParamsState: Ng2StateDeclaration = {
    name: "app.activities.day.with-params",
    url: "/{date:string}/{workplaceId:int}/{workgroupId:int}",
    views: {
        "main-view@app": {
            component: DayActitiesComponent
        }
    },
    resolve: {
        date: ["$stateParams", function ($stateParams) {
            return $stateParams.date ? new Date($stateParams.date) : new Date();
        }],
        workplaceId: ["$stateParams", function ($stateParams) {
            return $stateParams.workplaceId;
        }],
        workgroupId: ["$stateParams", function ($stateParams) {
            return $stateParams.workgroupId;
        }]
    }
};

export const overviewState: Ng2StateDeclaration = {
    name: "app.activities.overview",
    url: "/overview",
    views: {
        "main-view@app": {
            component: OverviewComponent
        }
    },
    resolve: {
        workplaceId: () => null,
        workgroupId: () => null,
        year: () => null,
        month: () => null
    }
};

export const overviewWithParamsState: Ng2StateDeclaration = {
    name: "app.activities.overview.with-params",
    url: "?{workplaceId:int}&{workgroupId:int}&{year:int}&{month:int}",
    views: {
        "main-view@app": {
            component: OverviewComponent
        }
    },
    resolve: {
        workplaceId: ["$stateParams", function ($stateParams) {
            return $stateParams.workplaceId !== -1 ? $stateParams.workplaceId : null;
        }],
        workgroupId: ["$stateParams", function ($stateParams) {
            return $stateParams.workgroupId !== -1 ? $stateParams.workgroupId : null;
        }],
        year: ["$stateParams", function ($stateParams) {
            return $stateParams.year;
        }],
        month: ["$stateParams", function ($stateParams) {
            return $stateParams.month - 1;
        }]
    }
};

export const workSchedulesState: Ng2StateDeclaration = {
    name: "app.activities.workschedules",
    url: "/workschedules",
    views: {
        "main-view@app": {
            component: WorkSchedulesComponent
        }
    },
    resolve: {
        workSchedules: [WorkSchedulesDataService.Id, function (workSchedulesDataService: WorkSchedulesDataService) {
            return workSchedulesDataService.getAll().then(res => res.filter(ws => ws.Active));
        }]
    }
};

export const workScheduleState: Ng2StateDeclaration = {
    name: "app.activities.workschedules.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: WorkScheduleComponent
        }
    },
    resolve: {
        workSchedule: [WorkSchedulesDataService.Id, "$stateParams", function (workSchedulesDataService: WorkSchedulesDataService, $stateParams) {
            return workSchedulesDataService.get($stateParams.id);
        }]
    }
};

export const editWorkScheduleState: Ng2StateDeclaration = {
    name: "app.activities.workschedules.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditWorkScheduleComponent
        }
    },
    resolve: {
        isNew: function () {
            return false;
        },
        workSchedule: [WorkSchedulesDataService.Id, "$stateParams", function (workSchedulesDataService: WorkSchedulesDataService, $stateParams) {
            return workSchedulesDataService.get($stateParams.id);
        }]
    }
};

export const newWorkScheduleState: Ng2StateDeclaration = {
    name: "app.activities.workschedules.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditWorkScheduleComponent
        }
    },
    resolve: {
        isNew: function () {
            return true;
        },
        workSchedule: [function () {
            return <Nema.Crew.Model.WorkSchedule>{
                Name: "",
                Active: true,
                SortTag: "",
                Description: "",
                Steps: [],
                CreatedDate: new Date(),
                CreatedBy: ServiceConfig.loggedInUser
            };
        }]
    }
};

export const workScheduleMustersState: Ng2StateDeclaration = {
    name: "app.activities.workschedulemusters",
    url: "/workschedulemusters",
    views: {
        "main-view@app": {
            component: WorkScheduleMustersComponent
        }
    }
};

export const clearActivitiesState: Ng2StateDeclaration = {
    name: "app.activities.clearactivities",
    url: "/clearactivities",
    views: {
        "main-view@app": {
            component: ClearActivities
        }
    },
    resolve: {
        workplaceId: () => null,
        year: () => null,
        month: () => null
    }
}

export const clearActivitiesWithParamsState: Ng2StateDeclaration = {
    name: "app.activities.clearactivities.with-params",
    url: "?{workplaceId:int}&{year:int}&{month:int}",
    views: {
        "main-view@app": {
            component: ClearActivities
        }
    },
    resolve: {
        workplaceId: ["$stateParams", function ($stateParams) {
            return $stateParams.workplaceId !== -1 ? $stateParams.workplaceId : null;
        }],
        year: ["$stateParams", function ($stateParams) {
            return $stateParams.year;
        }],
        month: ["$stateParams", function ($stateParams) {
            return $stateParams.month - 1;
        }]
    }
};

export const timeBalanceMailState: Ng2StateDeclaration = {
    name: "app.activities.timebalancemail",
    url: "/timebalancemail",
    views: {
        "main-view@app": {
            component: TimeBalanceMailComponent
        }
    }
}

export const activityAdjustmentsState: Ng2StateDeclaration = {
    name: "app.activities.activityadjustments",
    url: "/activityadjustments",
    views: {
        "main-view@app": {
            component: AdjustmentsComponent
        }
    },
    resolve: {
        year: () => null,
        month: () => null
    }
}

export const activityAdjustmentsWithParamsState: Ng2StateDeclaration = {
    name: "app.activities.activityadjustments.with-params",
    url: "?{year:int}&{month:int}",
    views: {
        "main-view@app": {
            component: AdjustmentsComponent
        }
    },
    resolve: {
        year: ["$stateParams", function ($stateParams) {
            return $stateParams.year;
        }],
        month: ["$stateParams", function ($stateParams) {
            return $stateParams.month - 1;
        }]
    }
}

export const newActivityAdjustmentState: Ng2StateDeclaration = {
    name: "app.activities.activityadjustments.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: AdjustmentComponent
        }
    },
    resolve: {
        id: () => null
    }
}

export const editActivityAdjustmentState: Ng2StateDeclaration = {
    name: "app.activities.activityadjustments.edit",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: AdjustmentComponent
        }
    },
    resolve: {
        id: ["$stateParams", function ($stateParams) {
            return $stateParams.id;
        }]
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/activities.states.ts